export const config = {
  appName: import.meta.env.VITE_APP_NAME || 'PayRight',
  graphqlUrl: import.meta.env.VITE_GRAPHQL_URL || '/api/graphql',
  authMode: import.meta.env.VITE_AUTH_MODE === 'development' ? 'development' : 'keycloak',
  keycloakAuthority: import.meta.env.VITE_KEYCLOAK_AUTHORITY || 'https://auth-dev.fivebyfivelabs.com/realms/payright',
  keycloakClientId: import.meta.env.VITE_KEYCLOAK_CLIENT_ID || 'payright-web',
  defaultOrganizationId: import.meta.env.VITE_DEFAULT_ORGANIZATION_ID || ''
} as const;
